export default "__VITE_ASSET__DbcvwHAd__"